import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Magnify"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 15.75H3V3H16.5V9H18V3C18 2.17157 17.3284 1.5 16.5 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V15.75C1.5 16.5784 2.17157 17.25 3 17.25H9V15.75ZM20.1675 19.1025L22.5 21.435L21.435 22.5L19.1025 20.1675C17.1953 21.5212 14.569 21.1883 13.06 19.4015C11.5509 17.6147 11.6622 14.9697 13.3159 13.3159C14.9697 11.6622 17.6147 11.5509 19.4015 13.06C21.1883 14.569 21.5212 17.1953 20.1675 19.1025ZM13.5 16.5C13.5 18.1569 14.8431 19.5 16.5 19.5C18.1569 19.5 19.5 18.1569 19.5 16.5C19.5 14.8431 18.1569 13.5 16.5 13.5C14.8431 13.5 13.5 14.8431 13.5 16.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Magnify.vue"]]);
